import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import NextBtn from './NextBtn'

import sections from '../data/sections'
import subSections from '../data/subSections'

const SubSectionResultsList = ({ secId, subSectionData }) => {
    useEffect(() => {
        document.getElementById("section-anchor").scrollIntoView({behavior:"smooth"})
    }, [secId])
    
    useEffect(() => {
        document.getElementById("top-anchor").scrollIntoView({behavior:"smooth"})
    }, [])

    const currentSection = sections.find((section) => section.secId === secId)

    const nextArgs = secId === "patient" ? {nextLabel: "Results", nextLink: "/results"} : {nextLabel: "Next Concept", nextLink: `/menu/${sections[currentSection.number].secId}`}

    const findProps = (score) => {
        if (score <= 50) {
            return {
                word: "Area for Improvement",
                description: "The practice is in the beginning stages and/or has not considered many of the aspects related to the key component.",
                className: "low-score"
            }
        } else if (score <= 75) {
            return {
                word: "Almost Ready",
                description: "The practice has considered some aspects related to the key component.",
                className: "medium-score"
            }
        } else {
            return {
                word: "Ready",
                description: "The practice has considered many aspects related to the key component.",
                className: "high-score"
            }
        }
    }

    const displayScore = (score) => {
        const props = findProps(score)
        return (
        <div className="sub-score-container">
            <h4 className={`bold ${props.className}`}>{props.word}</h4>
            <p>{props.description}</p>
        </div>
        )
    }

    const toggleConceptMenu = () => {
        const conceptNav = document.getElementsByClassName("concept-nav")[0]
        conceptNav.classList.toggle("concept-nav--mobile")
    }

    return (
        <div className="page">
            <div className="grid-container">
                <div className="clear"></div>
                <div className="grid-x">
                    <div className="results-intro cell small-12">
                        <h3 className="bold">{`Key Components of ${currentSection.title}`}</h3>
                        <p>
                        Each telehealth concept is made up of one or more key components. Supporting guidance documents are provided with each key component to provide additional information that can help you improve your practice’s telehealth readiness in a particular area.
                        </p>
                    </div>
                </div>
            </div>

            <div className="collapsed-menu-bar collapsed-menu-bar--concepts" onClick={toggleConceptMenu}>
                <div className="menu-icon"></div>
                <div className="menu-title">Concept Menu</div>
            </div>

            <div className="grid-container">
                <div id="section-anchor" className="clear"></div>
                <div className="grid-x">
                    <div className="subsection-results cell small-12">
                        <div className="grid-x grid-margin-x results-side-by-side">
                            <ul className="section-tabs cell small-12 medium-3 concept-nav">
                                <Link className="back-btn" to="/start">
                                    <svg viewBox="0 0 30 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                        <path d="M1.78885438,6.10557281 L12.5527864,0.723606798 C13.0467649,0.476617549 13.6474379,0.676841896 13.8944272,1.17082039 C13.9638549,1.30967583 14,1.46278889 14,1.61803399 L14,6 L30,6 C30.5522847,6 31,6.44771525 31,7 C31,7.55228475 30.5522847,8 30,8 L14,8 L14,12.381966 C14,12.9342508 13.5522847,13.381966 13,13.381966 C12.8447549,13.381966 12.6916418,13.3458209 12.5527864,13.2763932 L1.78885438,7.89442719 C1.29487588,7.64743794 1.09465154,7.0467649 1.34164079,6.5527864 C1.43840449,6.359259 1.59532698,6.20233651 1.78885438,6.10557281 Z"></path>
                                    </svg>
                                    <p>Back</p>
                                </Link>
                                <div className="tab-links">
                                    { sections.map((section) => 
                                        <Link className={`tab ${(section.secId === secId) ? `active background--${secId} border--${secId}` : ""}`} to={`/menu/${section.secId}`} key={section.secId}>
                                        <div className="tab-content">
                                            <div className={`icon ${section.secId}-icon`} dangerouslySetInnerHTML={section.icon}></div>
                                            <p className="tab-title">{`${section.number}. ${section.title}`}</p>
                                        </div>
                                        </Link>
                                    )}
                                </div>
                            </ul>

                            <div className="subsection-results-list cell small-12 medium-9">
                                <h3 className={`bold background--${secId}`}>{`${currentSection.number}. ${currentSection.title}`}</h3>

                                { subSectionData.map((subSection) =>
                                    <div className={`subsection-result border--${secId}`} key={subSection.subSecId}>
                                        <div className="grid-x">
                                            <div className="cell small-12 medium-8 subsection-score-container">
                                                {subSection.title && <h4>{`${currentSection.number}${subSection.number}. ${subSection.title}`}</h4>}
                                                {!!subSection.score ? displayScore(subSection.score) : <div className="sub-score-container"><p>Answer questions for this key component to see your result.</p></div>}
                                            </div>

                                            <div className="cell small-12 medium-4 btn-group">
                                                <p className="answer-count">{`${subSection.numAnswered} out of ${subSection.totalQuestions} questions answered`}</p>
                                                <Link to={`/question/${secId}/${subSection.subSecId}/${subSection.firstQuestion}`} className="btn question-btn btn--key-component-menu">Answer Questions</Link>
                                                <Link className="btn question-btn btn--key-component-menu" to={`/guidance/${secId}/${subSection.subSecId}`}>View Guidance</Link>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="btn--next-concept">
                                    <NextBtn nextLabel={ nextArgs.nextLabel } nextLink={ nextArgs.nextLink } />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state, props) => {
    const secId = props.match.params.secId
    const metaData = subSections.filter((subSection) => subSection.secId === secId)
    const secAnswers = state.answers[secId]

    return {
        secId,
        subSectionData: metaData.map(subSection => (
        {
            firstQuestion: subSection.questions[0],
            numAnswered: Object.values(secAnswers[subSection.subSecId]).filter((answer) => answer !== "").length,
            number: subSection.number,
            score: state.scores.subSections[subSection.subSecId].score,
            subSecId: subSection.subSecId, 
            title: subSection.title,
            totalQuestions: subSection.questions.length
        }))
    }
}

export default connect(mapStateToProps)(SubSectionResultsList)



// WEBPACK FOOTER //
// ./src/components/SubSectionMenu.js